import React, { memo } from 'react';
import { quickViewButtonPropTypes } from 'core/propTypes/propTypes';
import { Pencil } from "lucide-react";

export const QuickViewButton = memo(({ onClick }) => (
  <button
    title="Quick View"
    data-bs-toggle="modal"
    data-bs-target="#quick_view_modal"
    onClick={onClick}
    className="product-card__quick-view d-none d-md-flex btn-primary"
  >
    <Pencil className="me-0" size={18} />
  </button>
));

QuickViewButton.propTypes = quickViewButtonPropTypes;
